import React from 'react';

class Title extends React.Component {
  render() {
    return (
      <h2>Tasks</h2>
    );
  }
};

export default Title;


// WEBPACK FOOTER //
// ./src/components/Title.js